import { LOCATION_TYPE } from '../../../shared/constants';
import { toFormFieldText } from '../../../shared/utils/formValue';
import { reportingCalendarYear } from '../../../shared/utils/reportingYear';
import {
  SCOPE_2_APPLICATION,
  toAssignmentForm,
  toAssignmentPayload,
} from './scope2Assignment';

export const EMPTY_OFFICE_FORM = {
  location_name_en: '',
  location_code: '',
  location_name_jp: '',
  location_address: '',
  location_type: LOCATION_TYPE.OFFICE,
  area_m2: '',
  effective_from_fiscal_year: String(reportingCalendarYear()),
  supplier_id: '',
  application_code: SCOPE_2_APPLICATION.CORPORATE_AVERAGE_REFERENCE,
  is_active: true,
};

/** Add mode passes no office and gets the blank viewmodel. */

export function toOfficeForm(office, fiscalYear = reportingCalendarYear()) {

  if (!office) {
    return { ...EMPTY_OFFICE_FORM, effective_from_fiscal_year: String(fiscalYear) };
  }

  return {
    location_name_en: toFormFieldText(office.location_name_en),
    location_code: toFormFieldText(office.location_code),
    location_name_jp: toFormFieldText(office.location_name_jp),
    location_address: toFormFieldText(office.location_address),
    location_type: office.location_type || LOCATION_TYPE.OFFICE,
    area_m2: toFormFieldText(office.area_m2),
    ...toAssignmentForm({ ...office, assignment_fiscal_year: fiscalYear }),
    is_active: office.is_active !== false,
  };
}

/** Split the Office master body from its reporting-year assignment body. */

export function toOfficePayload(values, { currentAssignment } = {}) {
  return {
    office: {
      location_name_en: values.location_name_en.trim(),
      location_code: values.location_code.trim(),
      location_name_jp: values.location_name_jp.trim(),
      location_address: values.location_address.trim(),
      location_type: values.location_type,
      // Blank means "not measured yet", not zero.
      area_m2: values.area_m2.trim() === '' ? null : Number(values.area_m2),
      is_active: values.is_active,
    },
    assignment: toAssignmentPayload(values, currentAssignment),
  };
}

/** Return the raw Add-mode code suggestion, or null when code is user-owned. */
export function suggestedLocationCode(locationNameEn, { isEdit, isOverridden }) {
  if (isEdit || isOverridden) return null;
  return locationNameEn;
}

/** Return the one-based visible row number after client-side filtering/sorting. */
export function officeRowNumber(page, rowsPerPage, index) {
  return (page * rowsPerPage) + index + 1;
}
